
//const xlsaccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
import { formatJsonLocation as fjl } from "../../components/renderers";
import { formatJsonDataset as fjd } from "../../components/renderers";


export const membershipconfig = {

    members: {
        service: {
            name: 'members',
            title: 'Members',
            key: 'dcd',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['ttl', 'Title'], ['fnm', 'First Name'],['otn', 'Other Name'], ['lnm', 'Last Name'], ['shc', 'Memberhip Code'],['gnm', 'Day Group'],
            ['dcd', 'Date Created'], ['sts', 'Status']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'ttl', label: 'Member Title', type: 'fa', col: 1, req: 1, ops: {}, cp: { t: 'lcs', s: 'title' } },
                { id: 'fnm', label: 'First Name', type: 'tf', col: 1, req: 1, ops: {} },
                { id: 'otn', label: 'Other Name', type: 'tf', col: 1, req: 0, ops: {} },
                { id: 'lnm', label: 'Last Name', type: 'tf', req: 1, ops: {} },
                { id: 'gid', label: 'Gender', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'gender' } },
                { id: 'ddb', label: 'Date of Birth', type: 'df', req: 1, ops: {}, },
                { id: 'pob', label: 'Place of Birth', type: 'tf', req: 1, ops: {}, },
                { id: 'cid', label: 'Country', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'country' } },
                { id: 'hmt', label: 'Hometown', type: 'tf', req: 1, ops: {} },
                { id: 'rdd', label: 'District', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'district' } },
                { id: 'hrd', label: 'Home Region', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'region' } },
                { id: 'rad', label: 'Residential Address', type: 'tf', req: 1, ops: {} },
                { id: 'rpa', label: 'Postal Address', type: 'tf', req: 0, ops: {} },
                { id: 'ema', label: 'Email', type: 'tf', req: 1, ops: {} },
                { id: 'con', label: 'Contact Number', type: 'tf', req: 1, ops: {} },
                { id: 'ccn', label: 'Secondary Contact Number', type: 'tf', req: 0, ops: {} },
                { id: 'gun', label: 'Guardian Name', type: 'tf', req: 0, ops: {} },
                { id: 'gcn', label: 'Guardian Contact', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'fid', label: 'Parent Name', type: 'tf', req: 1, col: 2, ops: {}, },
                { id: 'mrd', label: 'Marital Status', type: 'fa', col: 2, req: 1, ops: {}, cp: { t: 'bcs', s: 'maritalstatus' }, chs: ['mti', 'mad', 'pom', 'spn', 'sid', 'spc', 'sdi',], },
                { id: 'mti', label: 'Marriage Type', type: 'fa', col: 2, req: 0, ops: {}, cp: { t: 'bcs', s: 'marriagetype' }, pns: ['mrd'] },
                { id: 'mad', label: 'Marriage Date', type: 'df', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'pom', label: 'Place of Marriage', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'spn', label: 'Spouse Name', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'sid', label: 'Spouse Country', type: 'fa', col: 2, req: 0, ops: {}, cp: { t: 'bcs', s: 'country' }, pns: ['mrd'] },
                { id: 'spc', label: 'Spouse Contact', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'sdi', label: 'Spouse Denomination', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'oid', label: 'Occupational Status', type: 'fa', col: 2, req: 1, ops: {}, cp: { t: 'bcs', s: 'occupationalstatus' } },
                { id: 'ocd', label: 'Occupation', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'pph', label: 'Previous Parish', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'ppl', label: 'Parish Location', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'tmd', label: 'Membership Date', type: 'df', col: 2, req: 1, ops: {} },
                { id: 'exi', label: 'Extra Information', type: 'jf', col: 2, req: 0, ops: {} },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'wizard', edit: 'column', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    students: {
        service: {
            name: 'students',
            title: 'Students',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['ttl', 'Title'], ['fnm', 'First Name'], ['lnm', 'Last Name'], ['shc', 'Memberhip Code'],
            ['dcd', 'Date Created'], ['sts', 'Status']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'ttl', label: 'Member Title', type: 'fa', col: 1, req: 1, ops: {}, cp: { t: 'lcs', s: 'title' } },
                { id: 'fnm', label: 'First Name', type: 'tf', col: 1, req: 1, ops: {} },
                { id: 'otn', label: 'Other Name', type: 'tf', col: 1, req: 0, ops: {} },
                { id: 'lnm', label: 'Last Name', type: 'tf', req: 1, ops: {} },
                { id: 'gid', label: 'Gender', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'gender' } },
                { id: 'ddb', label: 'Date of Birth', type: 'df', req: 1, ops: {}, },
                { id: 'pob', label: 'Place of Birth', type: 'tf', req: 1, ops: {}, },
                { id: 'cid', label: 'Country', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'country' } },
                { id: 'hmt', label: 'Hometown', type: 'tf', req: 1, ops: {} },
                { id: 'rdd', label: 'District', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'district' } },
                { id: 'hrd', label: 'Home Region', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'region' } },
                { id: 'rad', label: 'Residential Address', type: 'tf', req: 1, ops: {} },
                { id: 'rpa', label: 'Postal Address', type: 'tf', req: 0, ops: {} },
                { id: 'ema', label: 'Email', type: 'tf', req: 1, ops: {} },
                { id: 'con', label: 'Contact Number', type: 'tf', req: 1, ops: {} },
                { id: 'ccn', label: 'Secondary Contact Number', type: 'tf', req: 0, ops: {} },
                { id: 'gun', label: 'Guardian Name', type: 'tf', req: 0, ops: {} },
                { id: 'gcn', label: 'Guardian Contact', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'fid', label: 'Parent Name', type: 'tf', req: 1, col: 2, ops: {}, },
                { id: 'mrd', label: 'Marital Status', type: 'fa', col: 2, req: 1, ops: {}, cp: { t: 'bcs', s: 'maritalstatus' }, chs: ['mti', 'mad', 'pom', 'spn', 'sid', 'spc', 'sdi',], },
                { id: 'mti', label: 'Marriage Type', type: 'fa', col: 2, req: 0, ops: {}, cp: { t: 'bcs', s: 'marriagetype' }, pns: ['mrd'] },
                { id: 'mad', label: 'Marriage Date', type: 'df', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'pom', label: 'Place of Marriage', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'spn', label: 'Spouse Name', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'sid', label: 'Spouse Country', type: 'fa', col: 2, req: 0, ops: {}, cp: { t: 'bcs', s: 'country' }, pns: ['mrd'] },
                { id: 'spc', label: 'Spouse Contact', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'sdi', label: 'Spouse Denomination', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'oid', label: 'Occupational Status', type: 'fa', col: 2, req: 1, ops: {}, cp: { t: 'bcs', s: 'occupationalstatus' } },
                { id: 'ocd', label: 'Occupation', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'pph', label: 'Previous Parish', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'ppl', label: 'Parish Location', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'tmd', label: 'Membership Date', type: 'df', col: 2, req: 1, ops: {} },
                { id: 'exi', label: 'Extra Information', type: 'jf', col: 2, req: 0, ops: {} },
            ],
        },
        create: false,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'wizard', edit: 'column', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    document: {
        service: {
            name: 'document',
            title: 'Member Documents',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['dnm', 'Document Type'], ['rfn', 'Reference No'], ['prn', 'Parish No'], ['fnm', 'Member First Name'],['lnm', 'Member Last Name'],['url', 'URL'],
            ['dcd', 'Date Created'], ['sts', 'Status']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'rfn', label: 'Reference', type: 'tf', col: 1, req: 1, ops: {} },
                { id: 'prn', label: 'Parish No', type: 'tf', col: 1, req: 0, ops: {} },
                { id: 'mid', label: 'Member', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'member' } },
                { id: 'did', label: 'Document Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'documenttype' } },
                { id: 'ocd', label: 'Occupation', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'exi', label: 'Extra Information', type: 'jf', col: 2, req: 0, ops: {} },
            ],
        },
        create: false,
        actions: { view: 'View' },
        panels: {  view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    enrolmentrequests: {
        service: {
            name: 'enrolmentrequest',
            title: 'Enrolment Requests',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['dnm', 'Document Type'], ['rfn', 'Reference No'], ['prn', 'Parish No'], ['fnm', 'Member First Name'],['lnm', 'Member Last Name'],['url', 'URL'],
            ['dcd', 'Date Created'], ['sts', 'Status']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'rfn', label: 'Reference', type: 'tf', col: 1, req: 1, ops: {} },
                { id: 'prn', label: 'Parish No', type: 'tf', col: 1, req: 0, ops: {} },
                { id: 'mid', label: 'Member', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'member' } },
                { id: 'did', label: 'Document Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'documenttype' } },
                { id: 'ocd', label: 'Occupation', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'exi', label: 'Extra Information', type: 'jf', col: 2, req: 0, ops: {} },
            ],
        },
        create: false,
        actions: { view: 'View' },
        panels: {  view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    professionals: {
        service: {
            name: 'professionals',
            title: 'Professionals',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['ttl', 'Title'], ['fnm', 'First Name'], ['lnm', 'Last Name'], ['shc', 'Memberhip Code'],
            ['dcd', 'Date Created'], ['sts', 'Status']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'ttl', label: 'Member Title', type: 'fa', col: 1, req: 1, ops: {}, cp: { t: 'lcs', s: 'title' } },
                { id: 'fnm', label: 'First Name', type: 'tf', col: 1, req: 1, ops: {} },
                { id: 'otn', label: 'Other Name', type: 'tf', col: 1, req: 0, ops: {} },
                { id: 'lnm', label: 'Last Name', type: 'tf', req: 1, ops: {} },
                { id: 'gid', label: 'Gender', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'gender' } },
                { id: 'ddb', label: 'Date of Birth', type: 'df', req: 1, ops: {}, },
                { id: 'pob', label: 'Place of Birth', type: 'tf', req: 1, ops: {}, },
                { id: 'cid', label: 'Country', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'country' } },
                { id: 'hmt', label: 'Hometown', type: 'tf', req: 1, ops: {} },
                { id: 'rdd', label: 'District', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'district' } },
                { id: 'hrd', label: 'Home Region', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'region' } },
                { id: 'rad', label: 'Residential Address', type: 'tf', req: 1, ops: {} },
                { id: 'rpa', label: 'Postal Address', type: 'tf', req: 0, ops: {} },
                { id: 'ema', label: 'Email', type: 'tf', req: 1, ops: {} },
                { id: 'con', label: 'Contact Number', type: 'tf', req: 1, ops: {} },
                { id: 'ccn', label: 'Secondary Contact Number', type: 'tf', req: 0, ops: {} },
                { id: 'gun', label: 'Guardian Name', type: 'tf', req: 0, ops: {} },
                { id: 'gcn', label: 'Guardian Contact', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'fid', label: 'Parent Name', type: 'tf', req: 1, col: 2, ops: {}, },
                { id: 'mrd', label: 'Marital Status', type: 'fa', col: 2, req: 1, ops: {}, cp: { t: 'bcs', s: 'maritalstatus' }, chs: ['mti', 'mad', 'pom', 'spn', 'sid', 'spc', 'sdi',], },
                { id: 'mti', label: 'Marriage Type', type: 'fa', col: 2, req: 0, ops: {}, cp: { t: 'bcs', s: 'marriagetype' }, pns: ['mrd'] },
                { id: 'mad', label: 'Marriage Date', type: 'df', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'pom', label: 'Place of Marriage', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'spn', label: 'Spouse Name', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'sid', label: 'Spouse Country', type: 'fa', col: 2, req: 0, ops: {}, cp: { t: 'bcs', s: 'country' }, pns: ['mrd'] },
                { id: 'spc', label: 'Spouse Contact', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'sdi', label: 'Spouse Denomination', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'oid', label: 'Occupational Status', type: 'fa', col: 2, req: 1, ops: {}, cp: { t: 'bcs', s: 'occupationalstatus' } },
                { id: 'ocd', label: 'Occupation', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'pph', label: 'Previous Parish', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'ppl', label: 'Parish Location', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'tmd', label: 'Membership Date', type: 'df', col: 2, req: 1, ops: {} },
                { id: 'exi', label: 'Extra Information', type: 'jf', col: 2, req: 0, ops: {} },
            ],
        },
        create: false,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'wizard', edit: 'column', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    committees: {
        service: {
            name: 'committees',
            title: 'Committees',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { nme: 'Name', dsc: 'Description', ctn: 'Contact', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['nam', 'Name'], ['dsc', 'Description'], ['ctn', 'Contact'], ['trm', 'Term'], ['dcd', 'Date Created']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
                { id: 'shc', label: 'Short Code', type: 'tf', req: 1, ops: {} },
                { id: 'dsc', label: 'Description', type: 'tf', req: 0, ops: {} },
                { id: 'cnt', label: 'Contact', type: 'tf', req: 1, ops: {} },
                { id: 'trm', label: 'Term', type: 'tf', req: 1, ops: {} },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },

    birthday: {
        service: {
            name: 'birthday',
            title: 'Birthdays',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['fnm', 'First Name'], ['lnm', 'Last Name'], 
            ['dcd', 'Date Created'], ['sts', 'Status']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'fnm', label: 'First Name', type: 'tf', col: 1, req: 1, ops: {} },
                { id: 'otn', label: 'Other Name', type: 'tf', col: 1, req: 0, ops: {} },
                { id: 'lnm', label: 'Last Name', type: 'tf', req: 1, ops: {} },
                { id: 'gid', label: 'Gender', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'gender' } },
                { id: 'ddb', label: 'Date of Birth', type: 'df', req: 1, ops: {}, },
                { id: 'pob', label: 'Place of Birth', type: 'tf', req: 1, ops: {}, },
                { id: 'cid', label: 'Country', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'country' } },
                { id: 'hmt', label: 'Hometown', type: 'tf', req: 1, ops: {} },
                { id: 'rdd', label: 'District', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'district' } },
                { id: 'hrd', label: 'Home Region', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'region' } },
                { id: 'rad', label: 'Residential Address', type: 'tf', req: 1, ops: {} },
                { id: 'rpa', label: 'Postal Address', type: 'tf', req: 0, ops: {} },
                { id: 'ema', label: 'Email', type: 'tf', req: 1, ops: {} },
                { id: 'con', label: 'Contact Number', type: 'tf', req: 1, ops: {} },
                { id: 'ccn', label: 'Secondary Contact Number', type: 'tf', req: 0, ops: {} },
                { id: 'gun', label: 'Guardian Name', type: 'tf', req: 0, ops: {} },
                { id: 'gcn', label: 'Guardian Contact', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'fid', label: 'Parent Name', type: 'tf', req: 1, col: 2, ops: {}, },
                { id: 'mrd', label: 'Marital Status', type: 'fa', col: 2, req: 1, ops: {}, cp: { t: 'bcs', s: 'maritalstatus' }, chs: ['mti', 'mad', 'pom', 'spn', 'sid', 'spc', 'sdi',], },
                { id: 'mti', label: 'Marriage Type', type: 'fa', col: 2, req: 0, ops: {}, cp: { t: 'bcs', s: 'marriagetype' }, pns: ['mrd'] },
                { id: 'mad', label: 'Marriage Date', type: 'df', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'pom', label: 'Place of Marriage', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'spn', label: 'Spouse Name', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'sid', label: 'Spouse Country', type: 'fa', col: 2, req: 0, ops: {}, cp: { t: 'bcs', s: 'country' }, pns: ['mrd'] },
                { id: 'spc', label: 'Spouse Contact', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'sdi', label: 'Spouse Denomination', type: 'tf', col: 2, req: 0, ops: {}, pns: ['mrd'] },
                { id: 'oid', label: 'Occupational Status', type: 'fa', col: 2, req: 1, ops: {}, cp: { t: 'bcs', s: 'occupationalstatus' } },
                { id: 'ocd', label: 'Occupation', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'pph', label: 'Previous Parish', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'ppl', label: 'Parish Location', type: 'tf', col: 2, req: 0, ops: {} },
                { id: 'tmd', label: 'Membership Date', type: 'df', col: 2, req: 1, ops: {} },
                { id: 'exi', label: 'Extra Information', type: 'jf', col: 2, req: 0, ops: {} },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'wizard', edit: 'column', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },

    executives: {
        service: {
            name: 'executives',
            title: 'Executives',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['ern', 'Role'], ['esb', 'Esbec No'], ['nam', 'Name'], ['nnm', 'Nickname'], ['mbl', 'Mobile'], ['lcn', 'Location'], ['ecn', 'Country'], ['dcd', 'Date Created']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'eri', label: 'Role', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'executiverole' } },
                { id: 'esb', label: 'Code', type: 'tf', req: 1, ops: {} },
                { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
                { id: 'nnm', label: 'Nickname', type: 'tf', req: 1, ops: {} },
                { id: 'mbl', label: 'Mobile', type: 'tf', req: 1, ops: {} },
                { id: 'eml', label: 'Email', type: 'tf', req: 1, ops: {} },
                { id: 'lci', label: 'Location', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'location' } },
                { id: 'eci', label: 'Country', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'country' } },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    officers: {
        service: {
            name: 'officers',
            title: 'Officers',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['orn', 'Role'], ['esb', 'Esbec No'], ['nam', 'Name'], ['nnm', 'Nickname'], ['mbl', 'Mobile'], ['lcn', 'Location'], ['ocn', 'Country'], ['dcd', 'Date Created']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'ori', label: 'Role', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'officerrole' } },
                { id: 'esb', label: 'Esbec No', type: 'tf', req: 1, ops: {} },
                { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
                { id: 'nnm', label: 'Nickname', type: 'tf', req: 1, ops: {} },
                { id: 'mbl', label: 'Mobile', type: 'tf', req: 1, ops: {} },
                { id: 'eml', label: 'Email', type: 'tf', req: 1, ops: {} },
                { id: 'lci', label: 'Location', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'location' } },
                { id: 'oci', label: 'Country', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'country' } },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },
    staff: {
        service: {
            name: 'staff',
            title: 'Staff',
            key: 'rid',
            num: true,
            pageMode: 'remote',
            fields: ['pid', 'rid', 'mno', 'sno', 'mti', 'mtc', 'mpi', 'mpc', 'mph', 'msi', 'msc', 'bat', 'ssi', 'ssc', 'sts', 'ast', 'stp'],
            params: { mno: 'MeterNo', sno: 'StsNo', mti: 'Type', mpi: 'Phase', msi: 'StatusId', bat: 'Batch', ssi: 'StateId', sts: 'Status' },
            grid: [['srn', 'Role'], ['nam', 'Name'], ['mbl', 'Mobile'], ['lcn', 'Location'], ['scn', 'Country'], ['dcd', 'Date Created']],
            bar: { pag: true, btn: ['view'] },
            menu: { mnu: [{ t: 'Meter', v: 'mno' }, { t: 'STS', v: 'sno' }], def: 'mno' },
            eform: [
                { id: 'sri', label: 'Role', type: 'tf', req: 1, ops: {} },
                { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
                { id: 'mbl', label: 'Mobile', type: 'tf', req: 1, ops: {} },
                { id: 'eml', label: 'Email', type: 'tf', req: 1, ops: {} },
                { id: 'lci', label: 'Location', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'location' } },
                { id: 'sci', label: 'Country', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'country' } },
                { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
                { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
            ],
        },
        create: true,
        actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
        panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
        formatters: { grid: { geo: fjl, exi: fjd } }
    },

}
